import api from '../services/api';

export interface TeamSSOConfig {
  id: string;
  teamId: string;
  provider: string;
  status: string;
  samlEntityId?: string;
  samlSsoUrl?: string;
  samlNameIdFormat?: string;
  spEntityId?: string;
  spAcsUrl?: string;
  domains: string[];
  forceSso: boolean;
  autoCreateUser: boolean;
  autoAssignTeam: boolean;
}

export interface CreateSSOConfigRequest {
  teamId: string;
  samlEntityId: string;
  samlSsoUrl: string;
  samlCertificate: string;
  samlNameIdFormat?: string;
  domains: string[];
  forceSso?: boolean;
  autoCreateUser?: boolean;
  autoAssignTeam?: boolean;
}

export interface UpdateSSOConfigRequest {
  samlEntityId?: string;
  samlSsoUrl?: string;
  samlCertificate?: string;
  samlNameIdFormat?: string;
  domains?: string[];
  forceSso?: boolean;
  autoCreateUser?: boolean;
  autoAssignTeam?: boolean;
  status?: string;
}

export interface SSOLoginLog {
  id: string;
  teamId: string;
  userId?: string;
  provider: string;
  email: string;
  externalId?: string;
  status: string;
  message?: string;
  ip: string;
  userAgent?: string;
  createdAt: string;
}

export interface SSOLoginInitResponse {
  ssoUrl: string;
  samlRequest: string;
  relayState?: string;
}

export interface SSOStatusResponse {
  requiresSSO: boolean;
  teamId?: string;
  forceSSO?: boolean;
}

export const ssoApi = {
  // 获取团队 SSO 配置
  getTeamSSOConfig: (teamId: string) =>
    api.get<{ config?: TeamSSOConfig }>(`/teams/${teamId}/sso`),

  // 创建团队 SSO 配置
  createTeamSSOConfig: (data: CreateSSOConfigRequest) =>
    api.post<TeamSSOConfig>(`/teams/${data.teamId}/sso`, data),

  // 更新团队 SSO 配置
  updateTeamSSOConfig: (teamId: string, data: UpdateSSOConfigRequest) =>
    api.put<TeamSSOConfig>(`/teams/${teamId}/sso`, data),

  // 删除团队 SSO 配置
  deleteTeamSSOConfig: (teamId: string) =>
    api.delete<void>(`/teams/${teamId}/sso`),

  // 获取 SSO 登录日志
  getSSOLoginLogs: (teamId: string) =>
    api.get<{ logs: SSOLoginLog[]; total: number }>(`/teams/${teamId}/sso/logs`),

  // 检查邮箱是否需要 SSO 登录
  checkSSOStatus: (email: string) =>
    api.get<SSOStatusResponse>(`/sso/check?email=${encodeURIComponent(email)}`),

  // 发起 SSO 登录
  initiateSSOLogin: (params: { email?: string; teamId?: string; redirect?: string }) =>
    api.get<SSOLoginInitResponse>(`/sso/login`, { params }),

  // 获取 SP Metadata
  getSPMetadata: (teamId: string) =>
    fetch(`/api/v1/sso/saml/metadata/${teamId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/xml',
      },
    }),
};
